import intlTelInput from "intl-tel-input";

export function phoneinput(elem, elements) {
  elements.each(function() {
    if (this) {
      const iti = intlTelInput(this, {
        utilsScript: "../../build/js/utils.js",
        initialCountry: this.dataset.countryCode || "us",
        nationalMode: false,
        preventInvalidDialCodes: true,
        formatOnDisplay: false,
      });

      // Store iti instance directly on the DOM element
      this._iti = iti;
    }
  });

  // Register validator once globally with correct 3-argument signature
  window.Parsley.addValidator("phoneValidate", {
    validateString: function(_value, _requirement, parsleyInstance) {
      const input = parsleyInstance.$element[0];
      const iti = input._iti;

      if (!iti) {
        return true;
      }

      const value = iti.getNumber();
      if (!value || value.length === 0) {
        return true;
      }

      return iti.isValidNumber();
    },
    messages: {
      en: I18n.t("js.valid_phone_number"), // eslint-disable-line no-undef
    },
  });
}

window.phoneinput = phoneinput;

$(document).ready(function() {
  var $inputs = $(".phone-input");

  if ($inputs.length) {
    phoneinput($inputs[0], $inputs);
  }

  $inputs.on("mousedown", function() {
    if ($(this).val().length === 0) {
      var val = $(this)
        .attr("placeholder")
        .split(" ")[0];
      $(this).val(val);
    }
  });
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/intl-tel-input.js